export default "__VITE_ASSET__DSweOCD5__"